import React, { useContext } from 'react';

import Permissions from '@/lib/permissions';
import AppPage from '@/ui/AppPage/AppPage';

import GrobnaMjesta from '@/models/groblja/grobna_mjesta';
import DataCentricPage from '@/ui/DataCentric/DataCentricPage';
import DataController from '@/lib/DataController';
import DialogContext from '@/context/DialogContext/DialogContext';
import GeneralTableDialog from '@/ui/Dialog/GeneralTableDialog';
import GeneralGrobljaDialog from '../GeneralGrobljaDialog';
import { AllowRowActionFn } from '@/@types/ui/Table';
import { DCRecord } from '@/@types/lib/dataController';
import GMKorisnici from '@/models/groblja/grobno_mjesto_korisnici';
import AdvancedGrobljaDialog from '../RegistarKorisnika/AdvancedGrobljaDialog';

const RegistarGrobnihMjestaKorisniciDataCentricPage = () => {
  const dc = new DataController(GrobnaMjesta);
  const dcGMKorisnici = new DataController(GMKorisnici);

  const { showDialog } = useContext(DialogContext);

  const handleRowAction: (action: string, id: number, record?: { [key: string]: any }) => void = (action, id) => {
    if (action === 'show_history') {
      showDialog(GeneralTableDialog, {
        mode: 'view',
        dc,
        onClose: () => {},
        level: 1,
        title: 'groblja:titles.grobna_mjesta_history',
        view: 'history',
        customPath: `${GrobnaMjesta.apiPath}/${id}/history`,
        tableId: 'grobna-mjesta-history',
      });
    }
  };

  const handleSecondaryRowAction: (action: string, id: number, record?: { [key: string]: any }) => void = (action, id, record) => {
    if (action === 'show_history') {
      showDialog(GeneralTableDialog, {
        mode: 'view',
        dc: dcGMKorisnici,
        onClose: () => {},
        level: 1,
        title: 'groblja:titles.korisnici_grobnog_mjesta_history',
        view: 'grobno_mjesto_korisnici_history',
        customPath: `${GrobnaMjesta.apiPath}/${record?.grobno_mjesto_id}/osobe/${id}/history`,
        tableId: 'grobna-mjesta-history',
      });
    }
  };

  const allowRowAction: AllowRowActionFn = (action: string, record: DCRecord) => {
    if (action === 'show_history' && record.has_history) {
      return true;
    }
    return false;
  };

  return (
    <AppPage titlett="groblja:titles.reg_grobnih_mjesta" needPermission={[Permissions.GrobljaManageOsnovniRegistri]}>
      <DataCentricPage
        tableIdentifier="reg_grobnih_mjesta_korisnici"
        primaryModel={GrobnaMjesta}
        primaryTitleToken="groblja:titles.reg_grobnih_mjesta"
        primaryView="default"
        primaryDialogComponent={GeneralGrobljaDialog}
        primaryAllowEdit
        primaryAllowAdd
        primaryAllowShow3DButton
        primaryAllowExport
        secondaryModel={GMKorisnici}
        secondaryTitleToken="groblja:titles.korisnici_grobnog_mjesta"
        secondaryView="grobno_mjesto_korisnici"
        secondaryDialogComponent={AdvancedGrobljaDialog}
        secondaryAllowEdit
        secondaryAllowAdd
        secondaryAllowColumnPicker
        baseRecordPath={GrobnaMjesta.apiPath}
        // secondaryBaseRecordPath={`system/${modelComments.apiPath}/entity`}
        // primaryQueryAttribute="entity_gid"
        childRecordRelativePath="osobe"
        foreignKeyField="grobno_mjesto_id"
        geomRelativePath=""
        allowShowImages={false}
        mapId={45}
        mapModel={GrobnaMjesta}
        allowCustomTableAction={allowRowAction}
        onCustomTableAction={handleRowAction}
        primaryAllowShowDeleted
        secondaryAllowShowDeleted
        secondaryAllowCustomTableAction={allowRowAction}
        secondaryOnCustomTableAction={handleSecondaryRowAction}
        secondaryAllowDocumentButton
      />
    </AppPage>
  );
};

export default RegistarGrobnihMjestaKorisniciDataCentricPage;
